import * as React from "react";
import { useMemo } from "react";
import CounterBadge from "security-app/components/Assets/AssetDetails/CounterBadge";
function VulnerabilitiesCount({ vulnerabilities }) {
  const count = useMemo(() => {
    const uniqueVulnerabilitiesIds = /* @__PURE__ */ new Set();
    vulnerabilities.forEach((vuln) => {
      (vuln.vulnerabilities || []).forEach((inVuln) => {
        uniqueVulnerabilitiesIds.add(`${inVuln.vulnerability_id}${inVuln.cve}`);
      });
    });
    return uniqueVulnerabilitiesIds.size;
  }, [vulnerabilities]);
  if (!vulnerabilities.length) return null;
  return /* @__PURE__ */ React.createElement(CounterBadge, { count, singular: "Vulnerability", plural: "Vulnerabilities" });
}
export default VulnerabilitiesCount;
